/**
 * Load Meta JavaScript SDK and initialize FB (Embedded Signup / Login for Business).
 */
export function loadFacebookSdk(appId, version = "v25.0") {
  if (!appId) {
    return Promise.reject(new Error("Facebook App ID is missing"));
  }

  return new Promise((resolve, reject) => {
    const init = () => {
      if (!window.FB) {
        reject(new Error("FB global not available"));
        return;
      }
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        cookie: true,
        xfbml: true,
        version,
      });
      resolve(window.FB);
    };

    if (window.FB) {
      init();
      return;
    }

    window.fbAsyncInit = init;

    if (document.getElementById("facebook-jssdk")) {
      const deadline = Date.now() + 15000;
      const timer = setInterval(() => {
        if (window.FB) {
          clearInterval(timer);
          init();
        } else if (Date.now() > deadline) {
          clearInterval(timer);
          reject(new Error("Facebook SDK load timeout"));
        }
      }, 50);
      return;
    }

    const s = document.createElement("script");
    s.id = "facebook-jssdk";
    s.async = true;
    s.defer = true;
    s.crossOrigin = "anonymous";
    s.src = "https://connect.facebook.net/en_US/sdk.js";
    s.onerror = () => reject(new Error("Failed to load Facebook SDK"));
    document.body.appendChild(s);
  });
}
